import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordGameSelectorComponent } from './password-game-selector/password-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PasswordGameCoreService } from './password-game-core.service';

@NgModule({
  declarations: [PasswordGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [PasswordGameCoreService],
  exports: [PasswordGameSelectorComponent],
})
export class PasswordGameCoreModule {}
